module.exports = __webpack_public_path__ + "img/icon_map_0_on_101.f6a08308.png";